var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16992 12.9775L20.5572 12.9775C22.4734 12.9775 24.0267 14.5308 24.0267 16.447L24.0267 17.7197C24.0267 19.6359 22.4734 21.1893 20.5572 21.1893L8.51548 21.1893",
    stroke: "#064259",
    strokeWidth: 1.73629,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21289 9.32763C6.78759 10.7529 5.98849 11.552 4.56319 12.9773L8.21289 16.627",
    stroke: "#064259",
    strokeWidth: 1.73629,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.ebb124e02ad5f09cc515e2e9807b8c78.svg";
export { ForwardRef as ReactComponent };